import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { requestBLForData } from '@/Redux/Sagas/Requests/others';
import { openAlert } from '@/UI/BaseComponents/Alert';
import { getLayout } from '@/Utils/auth';
import BaseMethods from 'AlignBaseUI/BaseMethods';
import { ControlTranslation, Modal } from 'AlignComponents';
import { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';
import { LuCalendarClock, LuCalendarHeart } from 'react-icons/lu';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import { constant } from "@/Utils/constants";
import { IoIosArrowBack } from 'react-icons/io';
import ReactSelect from 'react-select';
import { toggleLoader } from '@/Redux/Ducks/loaderSlice';
import { saveAttendanceRequest, saveLeaveRequest } from '@/Redux/Ducks/homeSlice';
import { setGlobalMessage } from '@/Redux/Ducks/messageSlice';
import { openConfirmation } from '@/UI/BaseComponents/Alert';

const Attendance = () => {
  const dispatch = useAppDispatch();

  const getLocalDateString: any = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  const today = getLocalDateString(new Date());

  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [changeEnabled, enableChange] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>(null);
  const [activeRequest, setActiveRequest] = useState<"Attendance" | "Leave" | null>(null);
  const [attendanceRequestPrid, setAttendanceRequestPrid] = useState<number>(0);
  const [leaveRequestPrid, setLeaveRequestPrid] = useState<number>(0);
  const [leaveTypeDisabled, toggleLeaveTypeDisabled] = useState<boolean>(false);
  const [timeIn, setTimeIn] = useState<string>('00:00');
  const [timeOut, setTimeOut] = useState<string>('00:00');
  const [reason, setReason] = useState<string>('');
  const [leaveDuration, setLeaveDuration] = useState<any>(null);
  const [leaveType, setLeaveType] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState<string>(today);
  const [dateTo, setDateTo] = useState<string>(today);
  const { employeeData, joiningDate, attendanceData, leaveData, weekHolidays, holidayData, leaveTypes, leaveRequests, attendanceRequests } = useAppSelector((state) => {
    const attendanceData = state.Home.SelfService.attendanceData.map((x: any) => {
      const attendanceDateTime = new Date(x.date);
      const attendanceDate = new Date(attendanceDateTime.getFullYear(), attendanceDateTime.getMonth(), attendanceDateTime.getDate());
      const timeIn = x.timein ? new Date(x.timein) : new Date("1900-01-01T00:00:00");
      const timeOut = x.timeout ? new Date(x.timeout) : new Date("1900-01-01T00:00:00");

      return {
        attendancedate: attendanceDate,
        attendancetimein: timeIn,
        attendancetimeout: timeOut
      }
    });

    const leaveData = state.Home.SelfService.leaveData.map(x => ({ ...x, leavetransactiondate: new Date(x.leavedate) }));
    const holidayData = state.Home.SelfService.holidayData.map(x => ({ ...x, date: new Date(x.date) }));

    return {
      employeeData: state.Home.SelfService.employeeData,
      joiningDate: new Date(state.Home.SelfService.employeeData.joiningdate),
      // joiningDate: new Date("2024-11-04"),
      attendanceData: attendanceData,
      weekHolidays: state.Home.SelfService.weekHolidays,
      leaveData: leaveData,
      holidayData: holidayData,
      leaveTypes: state.Home.SelfService.leaveBalance.map(x => ({
        label: x.leavetypestxt,
        value: x.leavetypeno
      })) as any,
      leaveRequests: state.Home.SelfService.leaveRequests,
      attendanceRequests: state.Home.SelfService.attendanceRequests
    }

  });

  const currentDateTime = new Date;
  const currentDate = new Date(currentDateTime.getFullYear(), currentDateTime.getMonth(), currentDateTime.getDate());

  const tileClassName = ({ date, view }: any) => {
    if (view !== 'month') return '';

    const isDisabled = tileDisabled({ date, view });

    const calendarDate = new Date(date.toDateString());
    const attendanceMarking = attendanceData.find(
      (x) => new Date(x.attendancedate).getTime() === calendarDate.getTime()
    );
    const leaveMarking = leaveData.find(
      (x) => new Date(x.leavetransactiondate).getTime() === calendarDate.getTime()
    );
    const holidayMarking = holidayData.find(
      (x) => new Date(x.date).getTime() === calendarDate.getTime()
    );
    const dayOfWeek = calendarDate.getDay();

    const isAbsent =
      joiningDate.getTime() < calendarDate.getTime() &&
      calendarDate.getTime() < currentDate.getTime() &&
      !leaveMarking &&
      !holidayMarking &&
      !attendanceMarking;

    if (attendanceMarking && !isDisabled) return 'present';
    if (leaveMarking && !isDisabled) return 'leave';
    if (holidayMarking && !isDisabled) return 'holiday';
    if (isAbsent && !isDisabled) return 'absent';

    return '';
  };

  const tileContent = ({ date, view }: any) => {
    if (view !== 'month') return null; // Only add content for month view

    const isDisabled = tileDisabled({ date, view });

    const calendarDate = new Date(`${date.toDateString()} 00:00:00`);
    const attendanceMarking = attendanceData.find(
      (x) => new Date(x.attendancedate).getTime() === calendarDate.getTime()
    );
    const leaveMarking = leaveData.find(
      (x) => new Date(x.leavetransactiondate).getTime() === calendarDate.getTime()
    );
    const holidayMarking = holidayData.find(
      (x) => new Date(x.date).getTime() === calendarDate.getTime()
    );
    const dayOfWeek = calendarDate.getDay();
    let absentMark = false;

    if (
      joiningDate.getTime() < date.getTime() &&
      date.getTime() < currentDate.getTime() &&
      !leaveMarking &&
      !holidayMarking &&
      !attendanceMarking
    ) {
      absentMark = true;
    }

    const timeInfo = attendanceMarking
      ? {
        checkIn: attendanceMarking.attendancetimein,
        checkOut: attendanceMarking.attendancetimeout,
      }
      : null;

    // return (
    //   <div className="subtitle">
    //     {/* {attendanceMarking && (
    //       <>
    //         {timeInfo?.checkIn.getTime() !== new Date('1900-01-01T00:00:00').getTime() && (
    //           <span>
    //             {timeInfo?.checkIn.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
    //           </span>
    //         )}
    //         {timeInfo?.checkOut.getTime() !== new Date('1900-01-01T00:00:00').getTime() && (
    //           <span>
    //             {timeInfo?.checkOut.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
    //           </span>
    //         )}
    //       </>
    //     )} */}
    //     {/* {(leaveMarking && !isDisabled) && (
    //       <span className="leave">Leave</span>
    //     )}
    //     {(holidayMarking && !isDisabled) && (
    //       <span className="holiday">Holiday</span>
    //     )}
    //     {(absentMark && !isDisabled) && (
    //       <span className="absent">Absent</span>
    //     )} */}
    //   </div>
    // );

    return null;
  };

  const tileDisabled = ({ date, view }: any) => {
    if (view !== 'month') return false; // Only add content for month view

    const leaveMarking = leaveData.find(
      (x) => new Date(x.leavetransactiondate).getTime() === date.getTime()
    );
    const holidayMarking = holidayData.find(
      (x) => new Date(x.date).getTime() === date.getTime()
    );
    const dayOfWeek = date.getDay();

    let isDisabled =
      (weekHolidays.includes(dayOfWeek) && date.toDateString() !== new Date().toDateString()) ||
      (joiningDate.getTime() > date.getTime() && !leaveMarking && !holidayMarking);

    return isDisabled;
  };

  const openModal = async ({ date }: any) => {
    const calendarDate = new Date(date.toDateString());
    if (
      // currentDate.getTime() > calendarDate.getTime() &&
      joiningDate.getTime() <= calendarDate.getTime()
    ) {
      setModalVisible(true);

      const attendanceMarking = attendanceData.find(
        (x) => new Date(x.attendancedate).getTime() === calendarDate.getTime()
      );
      const leaveMarking = leaveData.find(
        (x) => new Date(x.leavetransactiondate).getTime() === calendarDate.getTime()
      );
      const holidayMarking = holidayData.find(
        (x) => new Date(x.date).getTime() === calendarDate.getTime()
      );

      let attendancetimein = "";
      let attendancetimeout = "";
      let absentMark = false;

      if (joiningDate.getTime() < calendarDate.getTime() && calendarDate.getTime() < currentDate.getTime() && !leaveMarking && !holidayMarking && !attendanceMarking) {
        absentMark = true
      }

      if (attendanceMarking) {
        const timein = attendanceMarking.attendancetimein;
        const timeout = attendanceMarking.attendancetimeout;
        // let checkInampm = timein.getHours() >= 12 ? 'PM' : 'AM';
        let checkInHours: any = timein.getHours();
        let checkInMinutes = timein.getMinutes().toString().padStart(2, '0');

        // if (checkInHours > 12) {
        //   checkInHours -= 12;
        // } else if (checkInHours === 0) {
        //   checkInHours = 12; // Convert midnight (0) to 12 AM
        // }

        // checkInHours = checkInHours.toString().padStart(2, '0'); // After adjustment

        // let checkOutampm = timeout.getHours() >= 12 ? 'PM' : 'AM';
        let checkOutHours: any = timeout.getHours();
        let checkOutMinutes = timeout.getMinutes().toString().padStart(2, '0');

        // if (checkOutHours > 12) {
        //   checkOutHours -= 12;
        // } else if (checkOutHours === 0) {
        //   checkOutHours = 12; // Convert midnight (0) to 12 AM
        // }

        // checkOutHours = checkOutHours.toString().padStart(2, '0'); // After adjustment

        attendancetimein = `${checkInHours}:${checkInMinutes}`;
        // ${checkInampm}

        attendancetimeout = `${checkOutHours}:${checkOutMinutes}`;
        // ${checkOutampm}
      }
      else if (absentMark) {
        attendancetimein = "";
        attendancetimeout = "";
      }

      setModalData({
        date: {
          ...date,
          calendarDate
        },
        forceAttendance: false,
        attendanceMarking,
        leaveMarking,
        holidayMarking,
        absentMark,
        attendancetimein,
        attendancetimeout
      });

      setTimeIn(attendancetimein);
      setTimeOut(attendancetimeout);
      setDateFrom(getLocalDateString(calendarDate));
      setDateTo(getLocalDateString(calendarDate));
    }
  }

  const closeModal = () => {
    setModalVisible(false);
    setModalData(null);
    enableChange(false);
    setTimeIn("00:00");
    setTimeOut("00:00");
    setReason("");
    setLeaveType(null);
    setLeaveDuration(null)
    setActiveRequest(null);
    setAttendanceRequestPrid(0);
    setLeaveRequestPrid(0);
    toggleLeaveTypeDisabled(false);
  }

  const requestChange = () => {
    enableChange(true);
  }

  const cancelChange = () => {
    setTimeIn(modalData.attendancetimein);
    setTimeOut(modalData.attendancetimeout);
    enableChange(false);
  }

  const saveChange = async () => {
    if (activeRequest == "Attendance") {
      let [tInHours, tInMinutes] = timeIn.split(":").map(Number);
      let [tOutHours, tOutMinutes] = timeOut.split(":").map(Number);

      dispatch(saveAttendanceRequest({
        prid: attendanceRequestPrid,
        employeeno: employeeData.employeeno,
        employeestxt: employeeData.employeestxt,
        isreferred: false,
        attendancerequestdate: new Date(modalData.date.calendarDate),
        attendancetimein: new Date(new Date(modalData.date.calendarDate).setHours(tInHours, tInMinutes, 0, 0)),
        attendancetimeout: new Date(new Date(modalData.date.calendarDate).setHours(tOutHours, tOutMinutes, 0, 0)),
        headertext: reason
      }));

      closeModal();
    }
    else if (activeRequest == "Leave") {
      dispatch(saveLeaveRequest({
        prid: leaveRequestPrid,
        employeeno: employeeData.employeeno,
        employeestxt: employeeData.employeestxt,
        isreferred: false,
        leavetypeno: leaveType.value,
        leaveduration: leaveDuration.value,
        datefrom: new Date(dateFrom),
        dateto: new Date(dateTo),
        notes: reason
      }));

      closeModal();
    }
  }

  const changeTimeIn = (val: any) => {
    setTimeIn(val);
  }

  const changeTimeOut = (val: any) => {
    setTimeOut(val);
  }

  const changeReason = (e: any) => {
    setReason(e.target.value);
  }

  const changeDateFrom = (e: any) => {
    setDateFrom(e.target.value);
  }

  const changeDateTo = (e: any) => {
    setDateTo(e.target.value);
  }

  const leaveDurations = ["First Half", "Second Half", "Full Day"].map(x => ({ label: x, value: x })) as any;

  const changeLeaveDuration = (e: any) => {
    setLeaveDuration(e);
  }

  const changeLeaveType = (e: any) => {
    setLeaveType(e);
  }

  const openLeave = async () => {
    const leaveRequestMarking = leaveRequests.find(
      (x) => new Date(x.datefrom).getTime() <= modalData.date.calendarDate.getTime() && new Date(x.dateto).getTime() >= modalData.date.calendarDate.getTime()
    );

    if (leaveRequestMarking) {
      if (leaveRequestMarking.isreferred) {
        dispatch(setGlobalMessage({
          message: 'This leave request cannot be updated as it has already been referred.'
        }))
        return;
      }

      setLeaveRequestPrid(leaveRequestMarking.prid);
      setLeaveType(leaveTypes.find((x: any) => x.value == leaveRequestMarking.leavetypeno));
      setLeaveDuration(leaveDurations.find((x: any) => x.value == leaveRequestMarking.leaveduration));
      setDateFrom(getLocalDateString(new Date(leaveRequestMarking.datefrom)));
      setDateTo(getLocalDateString(new Date(leaveRequestMarking.dateto)));
      setReason(leaveRequestMarking.notes);
      toggleLeaveTypeDisabled(true);

      const res = await openConfirmation({
        title: 'Are you sure you want to update your leave request?',
        text: 'You have already submitted leave requests for these dates.',
      });

      if (res.cancel) {
        closeModal();
        return;
      }
    }

    setActiveRequest("Leave");
  }

  const openAttendance = async () => {
    const attendanceRequestMarking = attendanceRequests.find(
      (x) => new Date(x.attendancerequestdate).getTime() == modalData.date.calendarDate.getTime()
    );

    if (attendanceRequestMarking) {
      if (attendanceRequestMarking.isreferred) {
        dispatch(setGlobalMessage({
          message: 'This attendance request cannot be updated as it has already been referred.'
        }))
        return;
      }

      setAttendanceRequestPrid(attendanceRequestMarking.prid);
      const timein = new Date(attendanceRequestMarking.attendancetimein);
      const timeout = new Date(attendanceRequestMarking.attendancetimeout);
      let checkInHours: any = timein.getHours();
      let checkInMinutes = timein.getMinutes().toString().padStart(2, '0');
      let checkOutHours: any = timeout.getHours();
      let checkOutMinutes = timeout.getMinutes().toString().padStart(2, '0');
      setTimeIn(`${checkInHours}:${checkInMinutes}`);
      setTimeOut(`${checkOutHours}:${checkOutMinutes}`);
      setReason(attendanceRequestMarking.headertext);

      const res = await openConfirmation({
        title: 'Are you sure you want to update your attendance request?',
        text: 'You have already submitted attendance request for this date.',
      });

      if (res.cancel) {
        closeModal();
        return;
      }
    }

    setActiveRequest("Attendance");
  }

  return (
    <>
      <Modal
        close={closeModal}
        heading={
          modalData ?
            BaseMethods.convertDateToCompanyFormat(modalData.date.calendarDate.toLocaleDateString(), constant.DefaultDateFormat)
            : ""
        }
        show={modalVisible}
        className="modal-request"
        footer={
          activeRequest ? (changeEnabled ? (
            <>
              <Button variant="light" onClick={() => setActiveRequest(null)}>
                <ControlTranslation system={true} controlId="btnback" />
              </Button>
              <Button variant="light" onClick={cancelChange}>
                <ControlTranslation system={true} controlId="btncancel" />
              </Button>
              <Button variant="primary" onClick={saveChange}>
                <ControlTranslation system={true} controlId="btnsave" />
              </Button>
            </>
          ) : <>
            <Button variant="light" onClick={() => setActiveRequest(null)}>
              <ControlTranslation system={true} controlId="btnback" />
            </Button>
            <Button variant="primary" onClick={requestChange}>
              <ControlTranslation system={true} controlId="btnrequestchange" />
            </Button>
          </>) : undefined
        }
      >
        <div>
          {
            modalData ?
              <>
                {
                  weekHolidays.includes(modalData.date.calendarDate.getDay()) && !modalData.holidayMarking ?
                    <div className="text-group">
                      <img src={require("@/Assets/Images/weekend.png").default} alt="" />
                      <h6>
                        <ControlTranslation system={true} controlId="lblweekend" />
                      </h6>
                      <span>
                        <ControlTranslation system={true} controlId="lblweekenddesc" />
                      </span>
                    </div>
                    : null
                }

                {
                  !activeRequest ? (
                    <div className="modal-request-options">
                      {
                        modalData.attendanceMarking || modalData.absentMark || modalData.forceAttendance ?
                          (
                            <div className="modal-request-option" onClick={openAttendance}>
                              <LuCalendarClock size={30} />
                              <ControlTranslation system={true} controlId="lblamendattendancerequest" />
                            </div>
                          ) : null
                      }
                      <div className="modal-request-option" onClick={openLeave}>
                        <LuCalendarHeart size={30} />
                        <ControlTranslation system={true} controlId="lblleaverequest" />
                      </div>
                    </div>
                  ) : activeRequest == "Attendance" ? (
                    <Form>
                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column md="4">
                          <ControlTranslation system={true} controlId="lbltimein" />:
                        </Form.Label>
                        <Col md="8">
                          <TimePicker onChange={changeTimeIn} value={timeIn} disabled={!changeEnabled} className="form-control" />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column md="4">
                          <ControlTranslation system={true} controlId="lbltimeout" />:
                        </Form.Label>
                        <Col md="8" >
                          <TimePicker onChange={changeTimeOut} value={timeOut} disabled={!changeEnabled} className="form-control" />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column md="4">
                          <ControlTranslation system={true} controlId="lblreason" />:
                        </Form.Label>
                        <Col md="8" >
                          <Form.Control as="textarea" rows={5} value={reason} onChange={changeReason} type="text" disabled={!changeEnabled} />
                        </Col>
                      </Form.Group>
                    </Form>
                  ) : activeRequest == "Leave" ? (
                    <>
                      <Form>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label column md="4">
                            <ControlTranslation system={true} controlId="lblleaveduration" />:
                          </Form.Label>
                          <Col md="8">
                            <ReactSelect options={leaveDurations} value={leaveDuration} onChange={changeLeaveDuration} isDisabled={!changeEnabled} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label column md="4">
                            <ControlTranslation system={true} controlId="lblleavetype" />:
                          </Form.Label>
                          <Col md="8">
                            <ReactSelect options={leaveTypes} value={leaveType} onChange={changeLeaveType} isDisabled={!changeEnabled || leaveTypeDisabled} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label column md="4">
                            <ControlTranslation system={true} controlId="lbldatefrom" />:
                          </Form.Label>
                          <Col md="8">
                            <Form.Control value={dateFrom} onChange={changeDateFrom} type="date" disabled={!changeEnabled} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label column md="4">
                            <ControlTranslation system={true} controlId="lbldateto" />:
                          </Form.Label>
                          <Col md="8">
                            <Form.Control value={dateTo} onChange={changeDateTo} type="date" disabled={!changeEnabled} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label column md="4">
                            <ControlTranslation system={true} controlId="lblreason" />:
                          </Form.Label>
                          <Col md="8" >
                            <Form.Control as="textarea" rows={5} value={reason} onChange={changeReason} type="text" disabled={!changeEnabled} />
                          </Col>
                        </Form.Group>
                      </Form>
                    </>
                  ) : null
                }


                {
                  modalData.leaveMarking ?
                    <>
                      <div className="text-group">
                        <img src={require("@/Assets/Images/holiday.png").default} alt="" />
                        <h6>
                          <ControlTranslation system={true} controlId="lblleavetext" />
                        </h6>
                        <span>
                          <ControlTranslation system={true} controlId="lblleavetextdesc" />
                        </span>
                      </div>
                    </>
                    : null
                }

                {
                  modalData.holidayMarking ?
                    <>
                      <div className="text-group">
                        <img src={require("@/Assets/Images/holiday.png").default} alt="" />
                        <h6>
                          <ControlTranslation system={true} controlId="lblholiday" />
                        </h6>
                        <span>{modalData.holidayMarking.heading}!</span>
                      </div>
                    </>
                    : null
                }
              </>
              : null
          }
        </div>
      </Modal>

      <Calendar
        tileContent={tileContent}
        tileDisabled={tileDisabled}
        tileClassName={tileClassName}
        nextLabel={getLayout()?.isEqual("RTL") ? <FiChevronLeft size={20} /> : <FiChevronRight size={20} />}
        next2Label={getLayout()?.isEqual("RTL") ? <FiChevronsLeft size={20} /> : <FiChevronsRight size={20} />}
        prevLabel={getLayout()?.isEqual("RTL") ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        prev2Label={getLayout()?.isEqual("RTL") ? <FiChevronsRight size={20} /> : <FiChevronsLeft size={20} />}
        locale={getLayout()?.isEqual("RTL") ? "ar-SA" : "en-US"}
        onClickDay={(date: any) => openModal({ date })}
      // onClickDay={(date) =>
      //   openModal(
      //     date,
      //     attendanceData.find((x) => x.attendancedate.getTime() === date.getTime()),
      //     leaveData.find((x) => x.leavetransactiondate.getTime() === date.getTime()),
      //     holidayData.find((x) => x.date.getTime() === date.getTime()),
      //     false
      //   )
      // }
      />
    </>
  );
};

export default Attendance;